import domtoimage from 'dom-to-image-more';
import { checkIsAuthCDNUrl } from './cdn';
import { isSafari } from '@umu/umu-ua';
import html2canvas from 'html2canvas';

interface DomToImageOptions {
    quality?: number;
    bgcolor?: string;
    style?: {
        zoom?: number;
        margin?: number;
    };
    scale?: number;
    useCredentials?: boolean;
}

export function base64ToImage(base64: string, scale: number, format: string, quality = 1) {
    return new Promise((resolve) => {
        const canvas = document.createElement('canvas');
        const ctx2D = canvas.getContext('2d') as CanvasRenderingContext2D;
        ctx2D.imageSmoothingEnabled = false;
        const zoom = window.devicePixelRatio * quality;
        const image = document.createElement('img');
        image.onload = function () {
            canvas.width = image.naturalWidth * scale;
            canvas.height = image.naturalHeight * scale;
            canvas.style.width = image.naturalWidth + 'px';
            canvas.style.height = image.naturalHeight + 'px';
            ctx2D.drawImage(image, 0, 0, canvas.width, canvas.height);
            ctx2D.scale(zoom, zoom);
            const dataUrl = canvas.toDataURL(format, quality);
            resolve(dataUrl);
        };
        image.src = base64;
    });
}

export function base64ToBlob(base64: string, mimeType?: string) {
    const reg = /^data:(.*);base64.*/;
    mimeType = mimeType || reg.exec(base64)?.[1] || '';
    const bytes = window.atob(base64.split(',')[1]);
    const ab = new ArrayBuffer(bytes.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeType });
}

export function domToImage(dom: any, options?: any): Promise<string> {
    return new Promise((resolve) => {
        // 参数检查
        if (!dom) {
            console.error('domToImage: dom parameter is required');
            resolve('');
            return;
        }

        const target = typeof dom === 'string' ? document.getElementById(`${dom}`) : dom;
        if (!target) {
            console.error('domToImage: target element not found');
            resolve('');
            return;
        }

        const params: DomToImageOptions = {
            quality: 1,
            bgcolor: '#fff',
            style: {
                zoom: 1,
                margin: 0,
            },
            scale: 4,
            ...options,
        };

        // 检查CDN URL并设置凭证
        if (target.outerHTML && checkIsAuthCDNUrl(target.outerHTML)) {
            params.useCredentials = true;
        }

        if (isSafari) {
            html2canvas(target, {
                useCORS: true,
                allowTaint: true,
                backgroundColor: null,
            })
                .then(function (canvas: HTMLCanvasElement) {
                    resolve(canvas.toDataURL('image/png'));
                })
                .catch(function (error: Error) {
                    console.error('html2canvas error:', error);
                    resolve('');
                });
        } else {
            domtoimage
                .toJpeg(target, params)
                .then(function (dataUrl: string) {
                    resolve(dataUrl);
                })
                .catch(function (error: Error) {
                    console.error('domtoimage error:', error);
                    resolve('');
                });
        }
    });
}
